import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
/* empty css          */
const PanelHeader = (t0) => {
  const $ = c(12);
  const {
    title,
    subtitle,
    actions
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = /* @__PURE__ */ jsx("h2", { className: "graphiql-panel-header-title", children: title });
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = subtitle && /* @__PURE__ */ jsx("p", { className: "graphiql-panel-header-subtitle", children: subtitle });
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = /* @__PURE__ */ jsxs("div", { className: "graphiql-panel-header-titles", children: [
      t1,
      t2
    ] });
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== actions) {
    t4 = actions && /* @__PURE__ */ jsx("div", { className: "graphiql-panel-header-actions", children: actions });
    $[7] = actions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = /* @__PURE__ */ jsxs("header", { className: "graphiql-panel-header", children: [
      t3,
      t4
    ] });
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export {
  PanelHeader
};
//# sourceMappingURL=index.js.map
